var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCalendarStar = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.84615 4.69226C2.35652 4.69226 1.88695 4.88677 1.54073 5.23299C1.1945 5.57921 1 6.04878 1 6.53841V23.1538C1 23.6434 1.1945 24.113 1.54073 24.4592C1.88695 24.8054 2.35652 25 2.84615 25H23.1538C23.6435 25 24.1131 24.8054 24.4593 24.4592C24.8055 24.113 25 23.6434 25 23.1538V6.53841C25 6.04878 24.8055 5.57921 24.4593 5.23299C24.1131 4.88677 23.6435 4.69226 23.1538 4.69226H19.4615",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M6.53845 1V8.38462",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M19.4615 1V8.38462",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M6.53845 4.69226H15.7692",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M11.9846 9.99078C12.0641 9.78608 12.2036 9.61019 12.3848 9.48617C12.566 9.36214 12.7804 9.29578 13 9.29578C13.2196 9.29578 13.434 9.36214 13.6152 9.48617C13.7964 9.61019 13.9359 9.78608 14.0154 9.99078L15.1969 13H18.3538C18.5603 13.0158 18.7582 13.089 18.925 13.2116C19.0919 13.3341 19.2211 13.5009 19.298 13.6931C19.3749 13.8853 19.3964 14.0952 19.36 14.299C19.3237 14.5029 19.2309 14.6924 19.0923 14.8462L16.3046 17.3569L17.4862 19.72C17.5931 19.9275 17.6293 20.1642 17.5894 20.3941C17.5494 20.6241 17.4353 20.8347 17.2646 20.9939C17.0951 21.155 16.8795 21.2594 16.6479 21.2925C16.4164 21.3256 16.1802 21.2857 15.9723 21.1785L13 19.5539L10.0277 21.1785C9.81979 21.2857 9.58365 21.3256 9.35206 21.2925C9.12047 21.2594 8.90493 21.155 8.73538 20.9939C8.56467 20.8347 8.45063 20.6241 8.41064 20.3941C8.37065 20.1642 8.40689 19.9275 8.51385 19.72L9.69538 17.3569L6.90769 14.8462C6.76908 14.6924 6.67632 14.5029 6.63996 14.299C6.6036 14.0952 6.62508 13.8853 6.70197 13.6931C6.77886 13.5009 6.90807 13.3341 7.07496 13.2116C7.24185 13.089 7.43973 13.0158 7.64615 13H10.8031L11.9846 9.99078Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCalendarStar);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/calendar_star.872e6efcd291ea0e1cce0251a367fe78.svg";